module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-tree-node",
    class: {
      expanded: _vm.childNodeRendered && _vm.expanded, 'is-current': _vm.$tree.currentNode === _vm._self
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "zk-tree-node__content",
    style: ({
      'padding-left': _vm.node.level * 16 + 'px'
    })
  }, [_c('span', {
    staticClass: "zk-tree-node__expand-icon",
    class: {
      'is-leaf': _vm.node.isLeaf, expanded: !_vm.node.isLeaf && _vm.expanded
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleExpandIconClick($event)
      }
    }
  }), _vm._v(" "), (_vm.showCheckbox) ? _c('zk-checkbox', {
    attrs: {
      "indeterminate": _vm.node.indeterminate
    },
    on: {
      "change": _vm.handleCheckChange
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleUserClick($event)
      }
    },
    model: {
      value: (_vm.node.checked),
      callback: function($$v) {
        _vm.node.checked = $$v
      },
      expression: "node.checked"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.node.loading) ? _c('span', {
    staticClass: "zk-tree-node__icon zk-icon-loading"
  }) : _vm._e(), _vm._v(" "), _c('node-content', {
    attrs: {
      "node": _vm.node
    }
  })], 1), _vm._v(" "), _c('collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "zk-tree-node__children"
  }, _vm._l((_vm.node.childNodes), function(child) {
    return _c('zk-tree-node', {
      attrs: {
        "render-content": _vm.renderContent,
        "node": child,
        "expanded-all": _vm.expandedAll
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-5fd8a4c0"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/tree/src/tree-node.vue
// module id = 259
// module chunks = 0